export const DOCS_ORIGIN = 'https://docs.exis.pro';

export interface FaqItem {
  id: string;
  question: string;
  answer: string;
  learnMore: { label: string; href: string };
}

function docsUrl(path: string): string {
  return `${DOCS_ORIGIN}${path}`;
}

export const faqItems: FaqItem[] = [
  {
    id: 'what-is-exis',
    question: 'What is Exis, in plain words?',
    answer:
      'Exis is a spreadsheet with AI agents built in. They watch your sheet, spot what is off, and suggest fixes as proposals. Nothing changes until you say yes.',
    learnMore: { label: 'How Exis works', href: docsUrl('/') },
  },
  {
    id: 'how-do-i-start',
    question: 'How do I get started?',
    answer:
      'Share a Google Sheet with agent@exis.pro, the same way you would share it with a colleague. The agent introduces itself in a comment, you click Activate, and proposals start arriving as comments.',
    learnMore: {
      label: 'Invite the agent',
      href: docsUrl('/guides/invite/'),
    },
  },
  {
    id: 'is-it-free',
    question: 'Is it free?',
    answer:
      'Yes, to start. Every account gets 25 free cell edits from agent proposals, including proposals from your own AI over MCP, across all your sheets. After that, Starter at $9 a month keeps your own AI editing, a Pro trial keeps the Exis agents going, and downloading your sheets always works.',
    learnMore: {
      label: 'Free cell edits and billing',
      href: docsUrl('/#free-cell-edits'),
    },
  },
  {
    id: 'can-it-break-my-numbers',
    question: 'Can the AI mess up my numbers?',
    answer:
      'No. Agents cannot touch a cell on their own. Every change they want to make shows up as a proposal with a before and after, and you decide whether it lands.',
    learnMore: {
      label: 'How proposals work',
      href: docsUrl('/guides/proposals/'),
    },
  },
  {
    id: 'is-my-data-safe',
    question: 'Who can see my spreadsheet?',
    answer:
      'Nobody reads a cell until you activate the sheet yourself. After that, the agent reads it to draft proposals and sends its contents to the AI providers named in our Privacy Policy. Remove agent@exis.pro from the sheet at any time and it all stops.',
    learnMore: {
      label: 'What the agent can see',
      href: docsUrl('/#what-the-agent-can-see'),
    },
  },
  {
    id: 'leave-google-sheets',
    question: 'Do I have to leave Google Sheets?',
    answer:
      'No. Keep working where you are. Exis lives in the comments of your sheet, and when you want a full editor, the same sheet is waiting for you in Exis.',
    learnMore: {
      label: 'Getting started',
      href: docsUrl('/#getting-started'),
    },
  },
];
